import React from "react";
import { AccordionSubTitle } from "@vds/accordions";
import { connect } from "react-redux";
import { AccordionStatus } from "../../constants/actionType";

function AccordionSubTitleRskn(props) {
  const {
    buildProduct, cart, isAccordionOpen, lqState, name, RecorderIncluded, selectedProduct, status, subtitle, title, Voicesubtitle,
  } = props;

  const selectedProductName = selectedProduct?.accordionTitle || selectedProduct?.name || selectedProduct || "";
  let vecFlow = lqState && lqState?.lqResponse && (lqState?.lqResponse?.hoaFlag === "V" || lqState?.lqResponse?.hoaFlag === "Y") ? true : false;
  function AccTitleaddText() {
    let subText = "";
    let perkSubText = "";
    let perkscnt = 0;
    const tvProductStatus = buildProduct?.tv?.selectedProduct;
    if (name == "toggle_internet_accor") {
      subText = buildProduct?.internet?.selectedProduct?.name;
      perkscnt = (buildProduct?.perks?.selectedProduct != null)
        ? buildProduct?.perks?.selectedProduct?.length
        : Array.isArray(cart?.cartData?.[0]?.perks?.perks)
          ? cart?.cartData?.[0].perks?.perks?.length
          : 0;
      perkSubText = perkscnt > 0
        ? ' & ' + perkscnt + (perkscnt == '1'
          ? ' perk added'
          : ' perks added'): "";

          // PRODDEF-39727: undefined Text is displayed in internet section when resuming the cart
          if(subText) {
            return subText?.toString?.()?.replace?.('4.0', '')?.replaceAll?.("&reg;", "\u00AE")
              + (tvProductStatus != null ? perkSubText : "");
          } else {
            return null;
          }
    } else if (name == "toggle_tv_accor") {
      const selectedProd = buildProduct?.tv?.selectedProduct?.name || '';
      const selectedProdSubText = selectedProd?.toString?.()?.replace?.('4.0', '')?.replace?.('4.1', '')?.replaceAll?.("&reg;", "\u00AE");
      
      return `${selectedProdSubText ? `${selectedProdSubText}` : ''}`;
    } else if (name == "toggle_phone_accor") {
      const selectedProd = buildProduct?.voice?.selectedProduct?.name || '';
      const selectedProdSubText = selectedProd?.toString?.()?.replace?.('4.0', '')?.replaceAll?.("&reg;", "\u00AE") || '';
      if (selectedProdSubText?.toLowerCase?.()?.trim?.() === 'home phone') {
        return `Fios ${selectedProdSubText}`
      } else {
        return selectedProdSubText;
      }
    } else {
      return 'Added';
    }
  }

  function subTitleReqText() {
    let subText = "";
    let SelectedprodName = "";
    if (name == "toggle_phone_intlcalling_accor") {
      subText = "- Choose your international calling destination.";
    } else if (name == "toggle_phone_backup_accor") {
      subText = "- Get a backup battery-powered device for phone service.";
    } else if (name == "toggle_phone_listing_accor") {
      subText = "- List your number in a directory. ";
    } else if (name == "toggle_phone_winbackcheck_accor") {
      subText = "- Use your current phone number with your new service or get a new one.";
    } else if (name == "toggle_emergency_services_accor") {
      subText = "- Use this line to support a fire alarm.";
    } else if (name === 'toggle_data_splOffer_accor') {
      subText = '- Choose one gift, included with your plan.';
    }
    //Added selectedProduct name, if exists for the parent internet,tv and phone accordions
    else if (name == "toggle_internet_accor" || name == "toggle_internet_plan_accor") {
      let SelectedprodName = buildProduct?.internet?.selectedProduct?.name ?? "";
      SelectedprodName = SelectedprodName?.replace?.("4.0", "")?.trim?.();
      return SelectedprodName;
    } else if (name == "toggle_tv_accor" || name == "toggle_tv_plan_accor") {
      SelectedprodName = buildProduct?.tv?.selectedProduct?.name ?? "";
      SelectedprodName = (SelectedprodName?.replace?.("4.0", ""))?.trim?.();
      return SelectedprodName;
    }
    else if (name == "toggle_phone_accor" || name == "toggle_phone_plan_accor") {
      SelectedprodName = buildProduct?.voice?.selectedProduct?.name ?? "";
      SelectedprodName = (SelectedprodName?.replace?.("4.0", ""))?.trim?.();
      return SelectedprodName;
    }
    else {
      subText = "";
    }
    return subText;
  }

  function subTitleOptTextTV() {
    let subText = "";
    if (name == 'toggle_internet_perks_accor') {
      subText = (buildProduct?.isMonarchView && !buildProduct?.internet?.selectedProduct)
        ? 'Optional - Please select internet plan first.'
        : "Optional - Choose your perks.";
    } else if (name == 'toggle_tv_internationalchannel_accor') {
      subText = "Optional - Choose your international channels.";
    } else if (name == 'toggle_tv_channel_accor') {
      subText = "Optional - Choose your favorite premium channels.";
    } else if (name == 'toggle_tv_ceapps_accor') {
      subText = "Optional - Choose your streaming device.";
    }
    return subText;
  }

  function subTitleOptText() {
    let subText = "";
    if (
      name == "toggle_phone_intlplans_accor" &&
      status == "optional"
    ) {
      subText = "Optional - Choose Verizon World Plan.";
    } else if (
      name == "toggle_emergency_services_accor" &&
      status == "optional"
    ) {
      subText = "Optional - Use this line to support a fire alarm.";
    } else if (name == "toggle_internet_techsure_accor") {
      subText = "Optional - Choose your option.";
    }
    else if (name == "toggle_phone_accor" && Voicesubtitle) {
      subText = Voicesubtitle;
    }
    return subText;
  }

  function subTitleaddText() {
    let subText = "";
    if (
      (name == "toggle_phone_intlplans_accor" ||
        name == "toggle_phone_backup_accor" ||
        name == "toggle_phone_listing_accor" ||
        name == "toggle_phone_winbackcheck_accor") &&
      status == "added"
    ) {
      subText = title?.[0];
    } else if (
      name == "toggle_phone_intlcalling_accor" &&
      status == "added"
    ) {
      subText = "Included - " + selectedProduct?.countryName;
    } else if (name == "toggle_tv_plan_accor") {
      subText = "Choose Live TV";
    } else if (name == "toggle_phone_plan_accor" && status == "added") {
      if (vecFlow){
        subText = selectedProduct?.name
      }else{
        subText = 'Fios Home Phone';
      }
    } else if(name=="toggle_emergency_services_accor" && status=="added"){
      subText= (selectedProduct?.value==="yes")?" Yes, I would use this line." : "No, don't use this line."
    } 
    else if (name == "toggle_internet_plan_accor") {
      subText = 'Choose your internet speed option';
    }
    return subText;
  }

  function getDataAccTitleOnSelection() {
    let title = (selectedProduct?.name || selectedProductName)?.replace?.('4.0', '')?.replaceAll?.("&reg;", "\u00AE");
    let offer ="";
    if(!selectedProduct?.name?.includes?.("100") && !selectedProduct?.name?.includes?.("300")){
      offer = buildProduct?.sploffer?.data?.selectedProduct?.OfferText;
    }  
    if (buildProduct?.router?.selectedProduct?.accordionTitle) {
      title += `, ${buildProduct?.router?.selectedProduct?.accordionTitle}`;
    }
    if (offer) {
      if (offer?.toLowerCase?.()?.includes?.('fios gaming')) {
        offer = offer?.replace?.('Fios', 'Xbox');
      }
      title += `, ${offer}`;
    }
    return title;
  }

  return (
    <>
      {buildProduct?.pendingProdNotification && status === ''
        && <AccordionSubTitle>
          <span>
            {(name === 'toggle_phone_plan_accor' && !buildProduct?.isMNEnabled)
              ? 'Choose your phone plan.'
              : ''
            }
          </span>
        </AccordionSubTitle>
      }
      {buildProduct?.pendingProdNotification && status === AccordionStatus.required
        && <AccordionSubTitle>
          <span style={{ color: ((name !== 'toggle_internet_router_accor' && name !== 'toggle_tv_router_accor') || (name==='toggle_tv_router_accor' && buildProduct?.router?.accordionStatus === AccordionStatus.required)) ? '#C44904' : '', paddingRight: '2px' }}>
            {name !== 'toggle_internet_router_accor'
              ? ((name !== "toggle_tv_router_accor" || name == "toggle_splOffer_accor") || (name==='toggle_tv_router_accor' && buildProduct?.router?.accordionStatus === AccordionStatus.required)
                ? 'Required'
                : 'Choose your router'
              )
              : ''
            }
          </span>
          <span>
            {name === 'toggle_tv_settopbox_accor'
              ? '- Choose your number of TV connections.'
              : name === 'toggle_splOffer_accor'
                ? '- Choose one gift, included with your plan.': (name==='toggle_tv_router_accor' && buildProduct?.router?.accordionStatus === AccordionStatus.required) ? '- Choose your router'
                : ''
            }
          </span>

          {subTitleReqText()}
        </AccordionSubTitle>
      }
      {selectedProduct && (selectedProduct?.price === 'Included' || selectedProduct?.[0]?.price === 'Included' || (selectedProduct?.displayPrice === '$0.00' && selectedProductName !== "Use your own router" && selectedProduct?.prodType === "ROUTERBILLER") || RecorderIncluded)
        ?
        <AccordionSubTitle>
          {buildProduct?.isMNEnabled
            ? name === "toggle_tv_recording_accor"
              ? 'Included -' + (selectedProduct?.name || selectedProductName)?.replace?.('4.0', '')?.replaceAll?.("&reg;", "\u00AE")
              : (name === "toggle_internet_router_accor"
                ? 'Included -' + (selectedProduct?.accordionTitle || selectedProductName)?.replace?.('4.0', '')?.replaceAll?.("&reg;", "\u00AE")
                : name === 'toggle_tv_settopbox_accor' && lqState?.hoaFlowDetails?.isHoaFlow ? buildProduct?.vRoom?.unitCount > 1
                  ? 'Included - ' + buildProduct?.vRoom?.unitCount + ' Set-top boxes ' : 'Included - ' + buildProduct?.vRoom?.unitCount + ' Set-top box'
                  : (selectedProduct?.accordionTitle || selectedProductName)?.replace?.('4.0', '')?.replaceAll?.("&reg;", "\u00AE")) || (selectedProduct?.prodName || selectedProductName)?.replace?.('4.0', '')?.replaceAll?.("&reg;", "\u00AE")
            : (name === "toggle_tv_ceapps_accor"
              ? 'Included - Unlimited'
              : (name === 'toggle_tv_settopbox_accor'
                ? lqState?.hoaFlowDetails?.isHoaFlow
                  ? buildProduct?.vRoom?.unitCount > 1
                    ? 'Included - ' + buildProduct?.vRoom?.unitCount + ' Set-top boxes '
                    : 'Included - ' + buildProduct?.vRoom?.unitCount + ' Set-top box'
                  : 'Added ' + (selectedProduct?.prodName || selectedProductName)
                : 'Included - ' + (selectedProduct?.prodName || selectedProductName)
              )
            )
          }
        </AccordionSubTitle>
        : status === AccordionStatus.completed
          ? <AccordionSubTitle> {AccTitleaddText()} </AccordionSubTitle>
          : status === AccordionStatus.actionRequired
            ? <AccordionSubTitle>
              {!buildProduct?.isMNEnabled && <span style={{ color: '#C44904' }}>Required</span>}
            </AccordionSubTitle>
            :
            <AccordionSubTitle>
              {status === AccordionStatus.added
                ? (name === "toggle_phone_intlplans_accor" || name === "toggle_phone_intlcalling_accor" || name === 'toggle_phone_winbackcheck_accor' || name === 'toggle_phone_listing_accor' || name === 'toggle_phone_backup_accor' || name=== "toggle_emergency_services_accor" || name === 'toggle_phone_plan_accor')
                  ? subTitleaddText()
                  : Array.isArray(selectedProduct) && selectedProduct?.length > 0
                    ? selectedProduct?.map?.(p => p?.name || p?.accordionTitle || p?.prodName)?.join?.(", ")?.replace?.('4.0', '')?.replaceAll?.("&reg;", "\u00AE")
                    : isAccordionOpen?(name==="toggle_tv_plan_accor" && status==="added")?(buildProduct?.tv?.selectedProduct?.name?(selectedProduct?.accordionTitle || selectedProduct?.name || selectedProductName)?.replace?.('4.1', '')?.replaceAll?.("&reg;", "\u00AE"):''):
                    // https://onejira.verizon.com/browse/PRODDEF-38439
                    // Header should be static as "Router", and Subtitle should change to whatever is selected...Router Only, Use Your Own Router, or Buy: Verizon Router.
                       (name === "toggle_tv_router_accor" && (selectedProduct?.name || selectedProductName) === 'Rent: Verizon Router') ? 'Router Only' : (selectedProduct?.name || selectedProductName)
                      : ((selectedProduct?.accordionTitle || selectedProductName) !== undefined && name === "toggle_internet_router_accor")
                        ? (selectedProduct?.accordionTitle || selectedProduct?.name || selectedProductName)?.replace?.('4.0', '')?.replaceAll?.("&reg;", "\u00AE")
                        : ((selectedProduct?.accordionTitle || selectedProductName) !== undefined && name === "toggle_internet_plan_accor")
                          ? !lqState?.isFCPflow ? (lqState?.hoaFlowDetails?.isHoaFlow ? 'Included - ' : '') + (selectedProduct?.name || selectedProductName)?.replace?.('4.0', '')?.replaceAll?.("&reg;", "\u00AE")
                            : getDataAccTitleOnSelection()
                          : (selectedProduct?.name || selectedProductName)?.replace?.('4.0', '')?.replaceAll?.("&reg;", "\u00AE") === 'Streaming'
                            ? '1 Gig'
                            : ((name === "toggle_tv_recording_accor" || name === "toggle_internet_router_accor" || name === "toggle_tv_settopbox_accor" || name === "toggle_tv_plan_accor")
                              // Temporary fix - revert (selectedProduct?.accordionTitle || selectedProduct?.name) back to selectedProduct?.accordionTitle once AEM is updated to define accordionTitle for products
                              ? name === "toggle_tv_settopbox_accor" && lqState?.hoaFlowDetails?.isHoaFlow && (selectedProduct?.name || selectedProduct?.accordionTitle || selectedProductName)?.toLowerCase?.()?.indexOf?.('fios tv')
                                ? buildProduct?.vRoom?.unitCount > 1
                                  ? 'Included - ' + buildProduct?.vRoom?.unitCount + ' Set-top boxes ' : 'Included - ' + buildProduct?.vRoom?.unitCount + ' Set-top box'
                                :  (selectedProduct?.accordionTitle || selectedProduct?.name || selectedProductName)?.replace?.('4.1', '')?.replaceAll?.("&reg;", "\u00AE")
                              : (lqState?.hoaFlowDetails?.isHoaFlow ? '' : '') + ((selectedProduct?.accordionTitle || selectedProductName) || (name === "toggle_data_splOffer_accor") ? (name === "toggle_tv_router_accor") ? (selectedProduct?.name || selectedProduct?.prodName || selectedProduct?.accordionTitle) : ('') : (selectedProduct?.name || selectedProductName))?.replace?.('4.0', '')?.replaceAll?.("&reg;", "\u00AE"))
                            || (selectedProduct?.accordionTitle || selectedProduct?.name || selectedProductName)?.replace?.('4.0', '')?.replaceAll?.("&reg;", "\u00AE")
                            || (selectedProduct?.name || selectedProductName)?.replace?.('4.0', '')?.replaceAll?.("&reg;", "\u00AE")
                : status === AccordionStatus.optional
                  ? (buildProduct?.isMNEnabled == undefined
                    ? subTitleOptTextTV()
                    : (!buildProduct?.isMNEnabled && !buildProduct?.internet?.mm3Qualified
                      ? subtitle?.replace?.('4.0', '')?.replaceAll?.("&reg;", "\u00AE")
                      : subTitleOptTextTV()
                    )
                  )
                  : buildProduct?.isMNEnabled && subtitle?.replace?.('4.0', '')?.replaceAll?.("&reg;", "\u00AE")
                    ? subtitle?.replace?.('4.0', '')?.replaceAll?.("&reg;", "\u00AE")
                    : (name === 'toggle_tv_plan_accor' || name === 'toggle_internet_plan_accor'
                      ? subTitleaddText()
                      : ''
                    )
              }
              {(selectedProduct?.accordionTitle || selectedProductName) === '' && subTitleOptText()}
            </AccordionSubTitle>
      }
      <AccordionSubTitle>
        {(name == 'toggle_phone_plan_accor' && status == "")
          ? ''
          : ''
        }
      </AccordionSubTitle>
      <AccordionSubTitle>
        {(name == 'toggle_data_splOffer_accor' && status === "added")
          ? buildProduct?.sploffer?.selectedProduct?.OfferText
          : ''
        }
      </AccordionSubTitle>
      
      <AccordionSubTitle>
        {(name == 'toggle_internet_perks_accor' && selectedProduct?.length == 0)
          ? <span>Optional - Choose your perks.</span>
          : ''
        }
      </AccordionSubTitle>
    </>
  );
}

const mapStateToProps = (state) => ({
  buildProduct: state?.buildProduct,
  cart: state?.cart,
  lqState: state?.loopQual,
});

export default connect(mapStateToProps)(AccordionSubTitleRskn);

